<template>
  <header>
    <div class="socials">
      <a href="#">
        <FacebookIcon/>
      </a>
      <a href="https://www.instagram.com/american.holocaust/" target="_blank">
        <InstagramIcon/>
      </a>
      <a href="#">
        <TwitterIcon/>
      </a>
    </div>
    <h1>American Holocaust</h1>
    <HamburgerMenu :items="menuItems" />
  </header>
</template>

<script>
import HamburgerMenu from './HamburgerMenu.vue'
import FacebookIcon from './icons/Facebook.vue'
import InstagramIcon from './icons/Instagram.vue'
import TwitterIcon from './icons/Twitter.vue'

export default {
  name: 'Header',
  components: {
    HamburgerMenu,
    FacebookIcon,
    InstagramIcon,
    TwitterIcon
  },
  data() {
    return {
      menuItems: [
        {
          text: "Home",
          link: "#hero"
        },
        {
          text: "About",
          link: "#about"
        },
        {
          text: "Merch",
          link: "#shop"
        }
      ]
    }
  }
}
</script>

<style scoped lang="scss">
header {
  display: flex;
  justify-content: space-between;
  padding: 16px;
  position: fixed;
  top: 0;
  background-color: white;
  width: 100%;
  box-sizing: border-box;
  border-top: 5px solid #c61e3a;
  z-index: 10;
  background-color: #eee;
  background-color: #1b305f;
  color: white;
  height: 60px;
}

.socials {
  display: flex;
  align-items: center;
  justify-content: space-between;

  a {
    svg {
      width: 24px;
      height: 24px;
      border: 2px solid white;
      padding: 2px;
      border-radius: 50%;
      margin-right: 0;
      fill: white;
    }

    &:hover {
      svg {
        fill: red;
        border: 2px solid red;
      }
    }

    &:focus {
      outline: none;
    }
  }
}

h1 {
  flex: 1;
  font-size: 18px;
  align-self: center;
  text-transform: uppercase;
  text-align: left;
  letter-spacing: 1px;
}

@media screen and (max-width: 767px) {
  .socials {
    display: none;
  }
}

@media screen and (min-width: 768px) {
  header {
    height: 87px;
  }

  .socials,
  nav {
    width: 136px;
  }

  h1 {
    font-size: 20px;
    align-self: center;
    text-align: center;
  }

  nav {
    position: relative;
    display: flex;
    justify-content: flex-end;
  }
}

@media screen and (min-width: 1280px) {
  h1 {
    font-size: 24px;
    letter-spacing: 3px;
  }
}
</style>